import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'arrayToPromiseAll'})
export class ArrayToPromiseAllPipe implements PipeTransform {

    async transform(array: any[]): Promise<any> {
        if (!Array.isArray(array)) {
            console.error('Usage: array | arrayToPromiseAll');
            return Promise.resolve([]);
        }
        return Promise.all(array).then((results) => results.filter((res) => !!res));
    }
}
